import UserApi from "@/api/user/UserApi";

const state = {
  selectedItem: null,
  drawer: true,
  mini: false,
  showTestComponent: false,
  items: [],
};

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
  },
  updateItems(state, items) {
    state.items = items;
  }
};

const actions = {
  async list({ commit }) {
    try {
      const response = await UserApi.menuListApi();
      if (Array.isArray(response)) {
        //console.log('menu', response);
        commit('SET_ITEMS', response);
      } else {
        console.error('error', response);
      }
    } catch (error) {
      console.error('error', error);
    }
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};